module.exports = __webpack_public_path__ + "static/media/nft6.638d79fc.jpg";